import { render, staticRenderFns } from "./badgeDate.vue?vue&type=template&id=0393d42f&scoped=true"
import script from "./badgeDate.vue?vue&type=script&lang=js"
export * from "./badgeDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0393d42f",
  null
  
)

export default component.exports